import { getToken } from "./storage"; //updateUserLogin
import AuthAPI from "services/AuthAPI";

export const inactiveSessionKey = 'lastInactiveTime';
export const logoutSyncKey = "crm-logout-sync";

const MAXIMUM_INACTIVE_TIME = Number(window._env_?.REACT_APP_MAXIMUM_INACTIVE_TIME || process.env.REACT_APP_MAXIMUM_INACTIVE_TIME) || 15 * 60 * 1000;
const CHECK_INTERVAL = 5000;

const setLastTime = () => {
  window.localStorage.setItem(inactiveSessionKey, Date.now().toString());
};
// last token seen in this tab, so the session can still be invalidated
// on the server if the token is removed from localStorage directly
let lastKnownToken = null;
let isLoggingOut = false;

const forceLogout = () => {
  // already on /logout; redirecting again would reload in a loop
  if (window.location.pathname === "/logout") return;
  // token is cleared on /logout after calling the logout API
  window.localStorage.removeItem(inactiveSessionKey);
  window.localStorage.setItem(logoutSyncKey, Date.now().toString());
  window.location.href = "/logout";
};

const logoutWithLastKnownToken = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    if (lastKnownToken) {
      await new AuthAPI().logoutAPI(lastKnownToken);
    }
  } catch (error) {
    console.error("Logout API Error:", error);
  } finally {
    lastKnownToken = null;
    forceLogout();
  }
};

const checkInactivity = () => {
  const token = getToken();
  const lastInactiveTime = Number(
    window.localStorage.getItem(inactiveSessionKey)
  );

  if (!token) {
    logoutWithLastKnownToken();
    return;
  }

  lastKnownToken = token;

  if (!lastInactiveTime) {
    setLastTime();
    return;
  }

  const diff = Date.now() - lastInactiveTime;

  if (diff > MAXIMUM_INACTIVE_TIME) {
    console.log("⏱ Auto Logout Triggered");
    forceLogout();
  }
};
export const autoLogout = () => {

  if (!window.localStorage.getItem(inactiveSessionKey)) {
    setLastTime();
  }
 checkInactivity();

  const handleUserActivity = () => {
    setLastTime();
  };

  const events = ["mousedown","keypress","touchstart","click","scroll","mousemove"];

  events.forEach((event) =>
    window.addEventListener(event, handleUserActivity)
  );

  const intervalId = setInterval(checkInactivity, CHECK_INTERVAL);

  const handleTabFocus = () => {
    if (document.visibilityState === "visible") {
      checkInactivity();
    }
  };

  document.addEventListener("visibilitychange", handleTabFocus);
  window.addEventListener("focus", handleTabFocus);

  const handleStorage = (e) => {
    if (e.key === logoutSyncKey) {
      forceLogout();
    }
  };

  window.addEventListener("storage", handleStorage);

  return () => {
    events.forEach((event) =>
      window.removeEventListener(event, handleUserActivity)
    );
    document.removeEventListener("visibilitychange", handleTabFocus);
    window.removeEventListener("focus", handleTabFocus);
    window.removeEventListener("storage", handleStorage);
    clearInterval(intervalId);
  };
};
